import { getClearingSummary } from 'admin/actions/clearing';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import CSVButton from 'admin/components/shared/CSVButton';
import { toQueryParams } from 'admin/utils';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Balance from './Balance';
import FilterForm from './FilterForm';

class ClearingSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      summary: { topup: {}, payment: {}, refund_topup: {}, refund_payment: {} },
      from: moment().startOf('day'),
      to: moment().endOf('day'),
    };
    this.csvFileName = `clearing_summary_${moment().format('YYYYMMDDHHmmss')}.csv`;
    this.csvHeaders = [
      { label: 'organization_code', key: 'organization_code' },
      { label: 'organization_name', key: 'organization_name' },
      { label: 'shop_name', key: 'name' },
      { label: 'shop_external_id', key: 'shop_external_id' },
      { label: 'type', key: 'transfer_type' },
      { label: 'money_amount', key: 'money' },
      { label: 'money_count', key: 'money_count' },
      { label: 'point_amount', key: 'point' },
      { label: 'point_count', key: 'point_count' },
    ];
  }

  componentDidMount() {
    this.onClickFilter();
  }

  componentDidUpdate(prevProps) {
    if (this.props.userPrivateMoney.id !== prevProps.userPrivateMoney.id) {
      this.onClickFilter();
    }
  }

  onClickFilter = () => {
    this.fetchClearingSummary(
      this.props.userPrivateMoney.id,
      toQueryParams({ from: this.state.from, to: this.state.to })
    );
  };

  handleDateRangeChange = (range) => {
    this.setState({
      from: range.from,
      to: range.to,
    });
  };

  handleDateRangeSelectorChange = (range) => {
    this.setState(
      {
        from: range.from,
        to: range.to,
      },
      () => {
        this.onClickFilter();
      }
    );
  };

  fetchClearingSummary = (privateMoneyId, query) => {
    getClearingSummary(privateMoneyId, query).then((summary) => {
      this.setState({ summary });
    });
  };

  fetchClearingSummaryForCSV = () => {
    return getClearingSummary(
      this.props.userPrivateMoney.id,
      toQueryParams({ from: this.state.from, to: this.state.to })
    ).then((summary) => {
      const topupSummaries = summary.topup.shops.map((s) => {
        s.transfer_type = 'topup';
        return s;
      });
      const paymentSummaries = summary.payment.shops.map((s) => {
        s.transfer_type = 'payment';
        return s;
      });
      const refundTopupSummaries = summary.refund_topup.shops.map((s) => {
        s.transfer_type = 'refund topup';
        return s;
      });
      const refundPaymentSummaries = summary.refund_payment.shops.map((s) => {
        s.transfer_type = 'refund payment';
        return s;
      });
      return topupSummaries
        .concat(paymentSummaries)
        .concat(refundTopupSummaries)
        .concat(refundPaymentSummaries);
    });
  };

  isPeriodToValid = (current) => {
    if (this.state.from === null || typeof this.state.from === 'string') {
      return true;
    }
    return this.state.from.isBefore(current);
  };

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: '精算管理', href: '', active: true },
      { value: '精算サマリ', href: '', active: true },
    ];
    return (
      <div>
        <Breadcrumb items={crumb} />
        <FilterForm
          dateRange={{ from: this.state.from, to: this.state.to }}
          onDateRangeChange={this.handleDateRangeChange}
          onDateRangeSelectorChange={this.handleDateRangeSelectorChange}
          onClickFilter={this.onClickFilter}
          csvButton={
            <CSVButton
              fetchData={this.fetchClearingSummaryForCSV}
              fileName={this.csvFileName}
              headers={this.csvHeaders}
            />
          }
        />
        <Balance summary={this.state.summary} user={this.props.user} />
        {/* TODO: need to implement clearing info */}
        {/* <div className={styles.headline}>精算内容</div> */}
        {/* <Bill payment={dummyPayment} invoice={dummyClearing} /> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  userPrivateMoney: state.userPrivateMoney.selectedMoney,
});

export default connect(mapStateToProps, null)(ClearingSummary);
